import React from 'react';
import './Toolsbar.css'

function Toolsbar() {
    return (
        <div class="toolbar-area" style={{ borderBottom: '1px solid grey', color:'white' }}>
            <div class="row inner-tools-area" >
                <div className="col-md-2 toolsbar">
                    <ul className="text-left" style={{textAlign:'center'}}>
                        <li><a href="mailto:brotech1010@gmail.com">support@brotech.com</a></li>
                    </ul>
                </div>
                <div className="col-md-8 toolsbar" style={{borderLeft:'1px solid grey', borderRight:'1px solid grey'}}>
                    <ul className="d-flex justify-content-between">
                        <li><i class="fa fa-phone"></i><a href="tel:+918188053879">(+91)8188053879</a></li>
                        <li class="opening"> <i class="fa fa-clock-o"></i> Mon - Fri: 10:00 am - 08.00pm</li>
                    </ul>
                </div>
                <div className="col-md-2 toolsbar">
                    <ul className="d-flex justify-content-around">
                        <li><a href="https://www.instagram.com/brotech1010/"><i class="fa fa-instagram"></i></a></li>
                        <li><a href="https://twitter.com/BroTech487043"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/bro0tech/?viewAsMember=true"><i class="fa fa-linkedin"></i></a></li>
                        {/* <li><a href="#"><i class="fa fa-linkedin"></i></a></li> */}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Toolsbar
